import { render, staticRenderFns } from "./ExpertisePageEdit.vue?vue&type=template&id=adc2fb08&"
import script from "./ExpertisePageEdit.vue?vue&type=script&lang=ts&"
export * from "./ExpertisePageEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adc2fb08')) {
      api.createRecord('adc2fb08', component.options)
    } else {
      api.reload('adc2fb08', component.options)
    }
    module.hot.accept("./ExpertisePageEdit.vue?vue&type=template&id=adc2fb08&", function () {
      api.rerender('adc2fb08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Resource/Expertises/ExpertisePageEdit.vue"
export default component.exports